// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { Card, Typography } from '@mui/material';
import { Translation } from '@shared/ui-kit/providers';
import { formatToMoney, numberToFixed } from '@shared/ui-kit/utils';
import { defineComponent } from '@shared/ui-kit/utils/define-component';
import { useCurrentPositionDisplay } from './use-current-position-display';

export const CurrentPositionDisplay = defineComponent({
  displayName: 'CurrentPositionDisplay',
  useSetup: useCurrentPositionDisplay,
  View: ({ investment, quantity, currency }) =>
    investment === 0 && quantity === 0 ? null : (
      <Card variant="outlined" className="!rounded-lg !bg-white !p-3">
        <div className="flex items-center justify-between">
          <Typography variant="body2" color="text.secondary">
            <Translation ns="components" i18nKey="ticker-modal.current-position" />
          </Typography>
          <div className="flex items-center gap-4">
            <Typography variant="body2" color="text.secondary">
              <Translation
                ns="components"
                i18nKey="ticker-modal.shares"
                values={{ quantity: numberToFixed(quantity, 2) }}
              />
            </Typography>
            <Typography variant="body2" className="font-semibold">
              {formatToMoney(investment, currency)}
            </Typography>
          </div>
        </div>
      </Card>
    ),
});
